import * as React from 'react';

import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  Paper,
  Typography,
} from '@mui/material';

import { useSnackbar } from 'notistack';

import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';

import useGetAlertFromLocationState from '../../core/api/hooks/common/useGetAlertFromLocationState';

import FormCard from '../../components/FormCard';
import FormPaper from '../../components/FormPaper';
import SafetyEventDrafts from './SafetyEventDrafts';
import { getColor } from '../../core/colors';
import useGetApprovalList from '../../core/api/hooks/safety-event/useGetApprovalList';
import SafetyEventReportDataGrid from '../../components/safety-event-report/SafetyEventReportDataGrid';
import SafetyEventList from './SafetyEventList';
import { EventFormStatus } from '../../core/api/clients';

function SafetyEventHome() {
  const { metadata, ...roles } = useAuthorizedFormData();
  const approvalList = useGetApprovalList();
  const { enqueueSnackbar } = useSnackbar();

  const { message, isError, title, displayAlert } = useGetAlertFromLocationState();

  React.useEffect(() => {
    if (message && title && displayAlert) {
      enqueueSnackbar(message, { variant: isError ? 'error' : 'default' });
    }
  }, [message, isError, title, displayAlert]);

  if (!metadata) {
    return (
      <Alert severity="error">
        <AlertTitle>Error - Metadata not found</AlertTitle>
      </Alert>
    );
  }

  return (
    <React.Fragment>
      <Collapse in={roles.isContributor}>
        <FormCard
          disableAvatar
          disableLink
          color={metadata.color}
          rootRoute={metadata.route}
          title={metadata.reportType}
        >
          <Typography variant="h6" sx={{ mb: 0, color: getColor(metadata.color)[500], fontWeight: 300 }}>
            All Drafts
          </Typography>
          <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
            <SafetyEventDrafts />
          </Paper>
        </FormCard>
      </Collapse>
      <Collapse in={roles.isReader || roles.isContributor}>
        <FormPaper color={metadata.color}>
          <Box display="flex" alignItems="center" sx={{ mt: 1, mb: 2 }}>
            <Box display="flex" alignItems="center" flexGrow={1}>
              <Typography sx={{ mr: 2 }} variant="h5">
                Safety Event Forms
              </Typography>
            </Box>
          </Box>
          <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
            <SafetyEventList
              statuses={[EventFormStatus.Submitted, EventFormStatus.Approved, EventFormStatus.Final]}
              pageSize={25}
            />
          </Paper>
        </FormPaper>
      </Collapse>
    </React.Fragment>
  );
}

export default SafetyEventHome;
